var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emailsettings"},[_c('div',{staticClass:"main-wrapper"},[_c('main-header'),_c('settingsidebar'),_c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"content container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 offset-md-2"},[_c('emailform')],1)])])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }